// src/components/sections/Footer.jsx
import React from 'react';
import { Instagram, Twitter, Mail, Music } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Quick Links</h3>
          <nav className="footer-nav">
            <a href="/music">Music</a>
            <a href="/events">Events</a>
            <a href="/shop">Shop</a>
            <a href="/members">Members</a>
          </nav>
        </div>

        <div className="footer-section">
          <h3>Connect</h3>
          <div className="footer-social">
            <a href="https://www.instagram.com/sonny.souf" target="_blank" rel="noopener noreferrer">
              <Instagram size={20} />
              <span>Instagram</span>
            </a>
            <a href="https://x.com/SonnySOUF" target="_blank" rel="noopener noreferrer">
              <Twitter size={20} />
              <span>Twitter</span>
            </a>
            <a href="https://open.spotify.com/artist/6SkhrvUnO22BJkOp4Sal0q" target="_blank" rel="noopener noreferrer">
              <Music size={20} />
              <span>Spotify</span>
            </a>
            <a href="mailto:contact@sonnysouf.com">
              <Mail size={20} />
              <span>Email</span>
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h3>Contact</h3>
          <p>For bookings and inquiries:</p>
          <a href="mailto:bookings@sonnysouf.com">bookings@sonnysouf.com</a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} Sonny.SOUF. All rights reserved.</p>
        <p className="footer-trademark">SOUF (Sending Out Unique Frequencies) is a registered trademark.</p>
      </div>
    </footer>
  );
};

export default Footer;